import { render, staticRenderFns } from "./IpoInvestmentSchedule.vue?vue&type=template&id=92fc7598"
import script from "./IpoInvestmentSchedule.vue?vue&type=script&lang=js"
export * from "./IpoInvestmentSchedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports